import { Alert, AlertSection } from '@aloft/toolkit-shared';

import { type MutableRefObject, createContext } from 'react';

export const EMPTY_ALERTS: Record<AlertSection, Alert[]> = {
  adjustments: [],
  comparable: [],
  depreciatedCost: [],
};

export const AlertsContext = createContext<Record<AlertSection, Alert[]> | null>(null);
export const AlertsRefContext = createContext<MutableRefObject<Record<AlertSection, Alert[]>> | null>(
  null,
);
